import { scheduledMessageFilesStateForEmployeeGroupIdSelector } from '../../scheduled-message-files/scheduled-message-files-selectors';
import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';

export const loadEmployeeGroupScheduledMessageFiles = (
  orgId: number,
  employeeGroupId: number | string,
) =>
  createGenericDispatcher({
    name: 'LOAD_SCHEDULED_MESSAGE_FILES_BY_EMPLOYEE_GROUP',
    loadFunction: () =>
      Api.get(
        `/scheduled-message-files/getAll?orgId=${orgId}${
          typeof employeeGroupId === 'number' ? `&employeeGroupId=${employeeGroupId}` : ''
        }`,
      ),
    args: { orgId, employeeGroupId },
    shouldExecuteSelector: (state: any) =>
      scheduledMessageFilesStateForEmployeeGroupIdSelector(state, employeeGroupId),
  });
